import _ from "lodash";
import Axios from "axios"
import {notify, toastMSG} from '@/utils.js'

const generalsUri = 'lunch/getgenerals',
        loncheraSinNombre = "-- LONCHERA SIN NOMBRE--",
        easyLunchDeUsuario = "lunch/deusuario/";

let startGenerals = () => {
    return {
        lunch_cedes: [],
        lunch_grupo: []
    }
}

let startFilters = () => {
    return {
        cedes_id: null,
        grupos_id: null
    }
}

let getEasyLunchDeUsuario = async (usuarioId) => {
    try {
        let response = await Axios.get(easyLunchDeUsuario + usuarioId);
        if(!_.isObjectLike(response)){
            throw 'No fue posible procesar la respuesta';
        }
        toastMSG(response.msg, response.class);
        return (response.status) ? response : false ;
    } catch(e){
        notify(e)
        return false;
    }
}

let getGenerals = async () => {
    try {
        let response = await Axios.get(generalsUri);
        if(!_.isObjectLike(response)){
            throw 'No fue posible procesar la respuesta';
        }
        toastMSG(response.msg, response.class);
        return response.data;
    } catch(e){
        notify(e)
        return startGenerals()
    }
}

export {
    getGenerals,
    startGenerals, 
    startFilters,
    getEasyLunchDeUsuario,
    loncheraSinNombre,
}